<template>
  <div class="score-table styled-table table-line-sm">
    <div class="thead-ua">
      <div class="thead-item">
        <p>{{ 'javascript.horse_registration.score.score_description' | trans }}</p>
      </div>

      <div class="thead-item">
        <p>{{ 'javascript.horse_registration.score.judgeA' | trans }}</p>
      </div>

      <div class="thead-item">
        <p>{{ 'javascript.horse_registration.score.judgeB' | trans }}</p>
      </div>

      <div class="thead-item">
        <p>{{ 'javascript.horse_registration.score.judgeC' | trans }}</p>
      </div>

      <div class="thead-item">
        <p>{{ 'javascript.horse_registration.score.total' | trans }}</p>
      </div>
    </div>

    <div class="tbody-ua">
      <div class="tbody-item">
        <p>{{ 'javascript.horse_registration.score.type' | trans }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeA' | trans }}</strong>
        </p>
        <p>{{ qualification.type.A }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeB' | trans }}</strong>
        </p>
        <p>{{ qualification.type.B }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeC' | trans }}</strong>
        </p>
        <p>{{ qualification.type.C }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.total' | trans }}</strong>
        </p>
        <p><strong>{{ typeScore }}</strong></p>
      </div>
    </div>

    <div class="tbody-ua">
      <div class="tbody-item">
        <p>{{ 'javascript.horse_registration.score.movement' | trans }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeA' | trans }}</strong>
        </p>
        <p>{{ qualification.movement.A }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeB' | trans }}</strong>
        </p>
        <p>{{ qualification.movement.B }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeC' | trans }}</strong>
        </p>
        <p>{{ qualification.movement.C }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.total' | trans }}</strong>
        </p>
        <p><strong>{{ movementScore }}</strong></p>
      </div>
    </div>

    <div class="tbody-ua">
      <div class="tbody-item">
        <p>{{ 'javascript.horse_registration.score.quality_correctness_development' | trans }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeA' | trans }}</strong>
        </p>
        <p>{{ qualification.equality_of_body_confirmation.A }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeB' | trans }}</strong>
        </p>
        <p>{{ qualification.equality_of_body_confirmation.B }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeC' | trans }}</strong>
        </p>
        <p>{{ qualification.equality_of_body_confirmation.C }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.total' | trans }}</strong>
        </p>
        <p><strong>{{ equalityOfBodyConfirmationScore }}</strong></p>
      </div>
    </div>

    <div class="tbody-ua">
      <div class="tbody-item">
        <p>{{ 'javascript.horse_registration.score.overall_impression' | trans }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeA' | trans }}</strong>
        </p>
        <p>{{ qualification.overall_impression.A }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeB' | trans }}</strong>
        </p>
        <p>{{ qualification.overall_impression.B }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.judgeC' | trans }}</strong>
        </p>
        <p>{{ qualification.overall_impression.C }}</p>
      </div>

      <div class="tbody-item">
        <p class="d-md-none hidden-label">
          <strong>{{ 'javascript.horse_registration.score.total' | trans }}</strong>
        </p>
        <p><strong>{{ overallImpressionScore }}</strong></p>
      </div>
    </div>

    <div class="tbody-ua">
      <div class="tbody-item">
        <p><strong>{{ 'javascript.horse_registration.score.final_score' | trans }}</strong></p>
      </div>

      <div class="tbody-item empty"></div>

      <div class="tbody-item empty"></div>

      <div class="tbody-item empty"></div>

      <div class="tbody-item">
        <p>
          <big class="mb-0"><strong>{{ qualificationFinalScore }}</strong></big>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QualifiedFoalScore',

  props: {
    foal: {
      type: Object,
      require: true
    },

    currentEvent: {
      type: Object,
      require: true
    },

    locale: {
      type: String,
      default: 'en',
    },
  },

  data() {
    return {
      //
    }
  },

  mounted() {
    //
  },

  computed: {
    qualification() {
      if (!this.currentEvent || !this.currentEvent.pivot) {
        return null
      }

      return this.currentEvent.pivot.qualification
    },

    qualificationFinalScore() {
      if (!this.currentEvent || !this.currentEvent.pivot) {
        return null
      }

      return this.currentEvent.pivot.qualification_final_score
    },

    typeScore() {
      return this.calculateScore('type')
    },

    movementScore() {
      return this.calculateScore('movement')
    },

    equalityOfBodyConfirmationScore() {
      return (this.calculateScore('equality_of_body_confirmation') / 3).toFixed(2)
    },

    overallImpressionScore() {
      return this.calculateScore('overall_impression')
    }
  },

  methods: {
    sumWithNaNHandling(...args) {
      let sum = 0

      for (const arg of args) {
        if (isNaN(arg)) {
          continue
        }

        sum += parseFloat(arg)
      }

      return sum.toFixed(2)
    },

    calculateScore(propertyName) {
      if (!this.qualification) {
        return null
      }

      const {A, B, C} = this.qualification[propertyName]

      return this.sumWithNaNHandling(A, B, C)
    },
  }
}
</script>
